import throttle from 'lodash.throttle';
import React from 'react';
import styled from '@emotion/styled'
import { Grid } from 'style';


class GoertekTypesetComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      variableFontSupport: false,
      sliderValue: 50,
    }


    this.weights = { 0: 200, 1: 500, 2: 800 };
    this.boundaries = {
      height: 0
    }
    this.changed = this.changed.bind(this);
    this.mouseMove = this.mouseMove.bind(this);

    this.handleResize = this.handleResize.bind(this);
    this.trottledResize = throttle(this.handleResize, 500);

    this.audioActive = false;

    this.typeset = React.createRef();
    this.weight = React.createRef();
    this.frequency = React.createRef();
    this.list = React.createRef();

  }

  componentDidMount() {
    this.setState({ variableFontSupport: "fontVariationSettings" in document.documentElement.style }, this.addEventListeners);
  }

  componentWillUnmount() {
    this.removeEventListeners();
  }

  addEvent(node, event_type, _options) {

    var options = _options || {};
    options.callback = options.callback || node["callback"];
    options.bubble = (options.bubble !== "undefined") ? false : true;

    node.addEventListener(event_type, (options.scope ? options.callback.bind(options.scope) : options.callback), options.bubble);
  }
  removeEvent(node, event_type, _options) {

    var options = _options || {};
    options.callback = options.callback || node["callback"];
    options.bubble = (options.bubble !== "undefined") ? false : true;

    node.removeEventListener(event_type, options.callback, options.bubble);
  }

  addEventListeners() {
    window.addEventListener('mousemove', this.mouseMove);
    window.addEventListener('resize', this.trottledResize);
    this.handleResize();
  }

  removeEventListeners() {
    window.removeEventListener('mousemove', this.mouseMove);
    window.removeEventListener('resize', this.trottledResize);
  }

  handleResize() {
    this.boundaries = this.typeset.current.getBoundingClientRect();
  }

  mouseMove(event) {
    let weight;
    if (this.state.variableFontSupport) {

      weight = 300 - ((300 - 700) / 100) * Math.round(100 / document.documentElement.clientWidth * event.pageX);

      var frequency = 200 / 100 * Math.round(100 / this.boundaries.height * event.offsetY);

      // update properties
      this.list.current.style.setProperty("--elem-weight", weight);
      this.list.current.style.setProperty("--elem-frequency", frequency);

      // update frequency
      this.frequency.current.innerHTML = frequency;


    } else {

      weight = this.weights[Math.floor(event.pageX / (document.documentElement.clientWidth / 3))];

      // u.as(this.list.current, { "fontWeight": weight });
      this.list.current.style.setProperty("font-weight", weight);
    }

    // update weight
    this.weight.current.innerHTML = weight;
  }

  changed(event) {

    this.setState({ sliderValue: event.target ? event.target.value : event });

    let weight;
    if (this.state.variableFontSupport) {

      // update font vaue
      weight = 300 - ((300 - 700) / 100) * event.target.value;

      // update properties
      this.list.current.style.setProperty("--elem-weight", weight);
      this.list.current.style.setProperty("--elem-frequency", 100);

    } else {

      weight = this.weights[Math.min(Math.floor(event.target.value / (100 / 3)), 2)];
      // u.as(this.list.current, { "fontWeight": weight });
      this.list.current.style.setProperty("font-weight", weight);
    }

    // update weight
    this.weight.current.innerHTML = weight;
  }


  render() {
    const { variableFontSupport, sliderValue, letter } = this.state;
    const { media } = this.props;
    return (
      <Grid.Wrapper backgroundColor={'#000'}>
        <Typeset className={[`visible`, variableFontSupport ? 'support' : 'default'].join(' ')} /*removed innerRef*/ ref={this.typeset}>
          <dl className="description">
            <dt>Description</dt>
            <dd>Explore the alphabet</dd>
          </dl>

          <ul className="measurements">
            <li>
              <dl className="weight">
                <dt>Weight:</dt>
                <dd ref={this.weight}>450</dd>
              </dl>
            </li>
            <li>
              <dl className="frequency">
                <dt>Frequency:</dt>
                <dd ref={this.frequency}>100</dd>
              </dl>
            </li>
          </ul>

          <ul className="list" ref={this.list}>
            <li className="extended">A</li>
            <li className="extended">B</li>
            <li className="extended">C</li>
            <li className="extended">D</li>
            <li className="extended">E</li>
            <li className="extended">F</li>
            <li className="extended">G</li>
            <li className="extended">H</li>
            <li className="extended">I</li>
            <li className="extended">J</li>
            <li className="extended">K</li>
            <li className="extended">L</li>
            <li className="extended">M</li>
            <li className="extended">N</li>
            <li className="extended">O</li>
            <li className="extended">P</li>
            <li className="extended">Q</li>
            <li className="extended">R</li>
            <li className="extended">S</li>
            <li className="extended">T</li>
            <li className="extended">U</li>
            <li className="extended">V</li>
            <li className="extended">W</li>
            <li className="extended">X</li>
            <li className="extended">Y</li>
            <li className="extended">Z</li>
            <li className="extended">0</li>
            <li>1</li>
            <li>2</li>
            <li>3</li>
            <li>4</li>
            <li>5</li>
            <li>6</li>
            <li>7</li>
            <li>8</li>
            <li>9</li>
          </ul>

          <ul className="action">
            <li>
              <input type="range" min="1" max="100" value={sliderValue} onChange={this.changed} ref={this.action} />
            </li>
          </ul>
        </Typeset>
      </Grid.Wrapper>
    )
  }
}

const Typeset = styled.div`


  /* Goertek weights variables */
  @font-face {
    font-family: "GoertekGX";
    src: url("/fonts/GoertekVariableGX.ttf") format("truetype-variations"),
      url("/fonts/GoertekVariableGX.ttf") format("truetype");
  }

  /* Goertek osci variables */
  @font-face {
    font-family: "osciGX";
    src: url("/fonts/osciGX.ttf") format("truetype-variations"),
      url("/fonts/osciGX.ttf") format("truetype");
  }


  /* Goertek */
  @font-face {
    font-family: "Goertek";
    src: url("/fonts/Goertek-Bold.woff2") format("woff2"),
      url("/fonts/Goertek-Bold.woff") format("woff");
    font-weight: 800;
    font-style: normal;
  }

  @font-face {
    font-family: "Goertek";
    src: url("/fonts/Goertek-Regular.woff2") format("woff2"),
      url("/fonts/Goertek-Regular.woff") format("woff");
    font-weight: 500;
    font-style: normal;
  }

  @font-face {
    font-family: "Goertek";
    src: url("/fonts/Goertek-Light.woff2") format("woff2"),
      url("/fonts/Goertek-Light.woff") format("woff");
    font-weight: 200;
    font-style: normal;
  }


  ul, dl, dd, p{
    margin: 0;
    padding: 0;
    line-height: 1;
  }
  ul li {
    display: inline-block;
    vertical-align: top;
  }
  dl dt {display: none;}

  /* global slider syling & reset */
  input[type="range"] {-webkit-appearance: none; -webkit-tap-highlight-color: rgba(255, 255, 255, 0); width: 100%; height: 20px; margin: 0; border: none; padding: 0; background: transparent; outline: none;}
  input[type="range"]::-moz-range-track {border: inherit; background: transparent;}
  input[type="range"]::-ms-track {border: inherit; color: transparent; background: transparent;}
  input[type="range"]::-ms-fill-lower,
  input[type="range"]::-ms-fill-upper {background: transparent; height: 20px;}
  input[type="range"]::-ms-tooltip {display: none;}
  input[type="range"]::-webkit-slider-thumb {-webkit-appearance: none; background: transparent; width: 18px; height: 18px; border: none; border-radius: 20px; border: 1px solid #FFFFFF;}
  input[type="range"]::-moz-range-thumb {width: 18px; height: 18px; border: none; border-radius: 20px; background: transparent; border: 1px solid #FFFFFF;}
  input[type="range"]::-ms-thumb {width: 18px; height: 18px; border-radius: 20px; border: 1px solid #FFFFFF; background: transparent;}


  @media only screen and (max-width: 800px) {

  input[type="range"] {-webkit-appearance: none; -webkit-tap-highlight-color: rgba(255, 255, 255, 0); height: 30px; margin: 0; border: none; padding: 0; background: transparent; outline: none;}
  input[type="range"]::-moz-range-track {border: inherit; background: transparent;}
  input[type="range"]::-ms-track {border: inherit; color: transparent; background: transparent;}
  input[type="range"]::-ms-fill-lower,
  input[type="range"]::-ms-fill-upper {background: transparent; height: 30px;}
  input[type="range"]::-ms-tooltip {display: none;}
  input[type="range"]::-webkit-slider-thumb {-webkit-appearance: none; background: transparent; width: 28px; height: 28px; border: none; border-radius: 30px; border: 1px solid #FFFFFF;}
  input[type="range"]::-moz-range-thumb {width: 28px; height: 28px; border: none; border-radius: 30px; background: transparent; border: 1px solid #FFFFFF;}
  input[type="range"]::-ms-thumb {width: 28px; height: 28px; border-radius: 30px; border: 1px solid #FFFFFF; background: transparent;}
  }


  display: block;
  position: relative;
  padding: 80px 30px 50px;

  dl.description {position: absolute; top: 50px; left: 50px; line-height: 0; pointer-events: none;}
  dl.description dt {font-size: 14px; line-height: 1em; text-transform: uppercase; color: #FFFFFF; margin-right: 6px;}
  dl.description dd {font-size: 14px; line-height: 1em; text-transform: uppercase; color: #FFFFFF; display: inline-block;}

  ul.measurements {position: absolute; top: 50px; right: 50px; pointer-events: none;}
  ul.measurements li {display: block;}
  ul.measurements li dl {line-height: 0; text-align: right;}
  ul.measurements li dl dt {font-size: 14px; line-height: 1em; text-transform: uppercase; color: #FFFFFF; display: inline-block; margin-right: 6px;}
  ul.measurements li dl dd {font-size: 14px; line-height: 1em; text-transform: uppercase; color: #FFFFFF; display: inline-block; width: 28px;}

  ul.list {pointer-events: none;}
  &.support ul.list {
    font-variation-settings: "wght" var(--elem-weight, 500), "osci" var(--elem-frequency, 100);
  }
  ul.list li {
    display: inline-block;
    color: #FFFFFF; vertical-align: top;
    width: calc((100vw - 60px) / 9);
    height: calc((100vw - 60px) / 9);
    text-align: center;
    font-size: calc((100vw - 60px) / 9 - 40px);
    line-height: 1em;
    padding: 20px;
    cursor: pointer;
    box-sizing: border-box;
  }
  font-family: "Goertek", Verdana, sans-serif;

  &.support ul.list li {
    font-family: "GoertekGX", Verdana, sans-serif;
    font-variation-settings: inherit;
  }
  &.default ul.list li {font-weight: inherit;}

  ul.action {display: none;}
  ul.action li {}
  ul.action li input {}


  /* start media query */
  @media only screen and (max-width: 1400px) {

    padding: 60px 30px 50px;
    dl.description {top: 30px; left: 30px;}
    dl.description dt {font-size: 12px;}
    dl.description dd {font-size: 12px;}

    ul.measurements {top: 30px; right: 30px;}
    ul.measurements li {}
    ul.measurements li dl {}
    ul.measurements li dl dt {font-size: 12px;}
    ul.measurements li dl dd {font-size: 12px;}
    ul.list {}
    &.support ul.list {}
    ul.list li {
      width: calc((100vw - 60px) / 9);
      height: calc((100vw - 60px) / 9);
      font-size: calc((100vw - 60px) / 9 - 40px);
    }
    &.support ul.list li {}
    &.default ul.list li {}

    ul.action {}
    ul.action li {}
    ul.action li input {}
  }

  @media only screen and (max-width: 1000px) {

    dl.description {}
    dl.description dt {}
    dl.description dd {}

    ul.measurements {}
    ul.measurements li {}
    ul.measurements li dl {}
    ul.measurements li dl dt {}
    ul.measurements li dl dd {}
    ul.list {}
    &.support ul.list {}
    ul.list li {
      width: calc((100vw) / 6 - 10px);
      height: calc((100vw - 60px) / 6 - 10px);
      font-size: calc((100vw - 60px) / 6 - 20px);
    }
    &.support ul.list li {}
    &.default ul.list li {}

    ul.action {}
    ul.action li {}
    ul.action li input {}
  }

  @media only screen and (max-width: 800px) {

    padding: 50px 0 20px; width: 100%;
    dl.description {top: 30px; left: 10px;}
    dl.description dt {font-size: 10px;}
    dl.description dd {font-size: 10px;}

    ul.measurements {top: 30px; right: 10px;}
    ul.measurements li {}
    ul.measurements li dl {}
    ul.measurements li dl dt {font-size: 10px;}
    ul.measurements li dl dd {font-size: 10px;}
    ul.list {}
    &.support ul.list {}
    ul.list li {
      width: calc(100vw / 3);
      height: calc(100vw / 3);
      font-size: calc(100vw / 3 - 40px);
    }
    &.support ul.list li {}
    &.default ul.list li {}
    ul.list li.extended {display: none;}

    ul.action {position: relative; display: inline-block; width: calc(100vw - 20px); height: 10px; border-top: 1px solid #FFFFFF; margin: 30px 0 0 10px;}
    ul.action li {width: 100%; font-size: 0; margin-top: -15px;}
    ul.action li input {width: 100%; cursor: pointer;}
  }





`;

export default GoertekTypesetComponent;
